import { TOOLTIP_HIDE_EVENTS } from './constants';

// A single, ref-counted, passive window listener shared by all Trend charts.
// Replaces per-chart listeners so scrolling triggers O(1) work instead of O(number of charts).
let refCount = 0;

const hideStatusBarTooltip = () => {
    const customTooltip = document.querySelector('.status-bar-tooltip-fixed');
    if (customTooltip) {
        customTooltip.remove();
    }
};

export const acquireStatusBarTooltipHide = () => {
    refCount += 1;
    if (refCount === 1) {
        TOOLTIP_HIDE_EVENTS.forEach(event =>
            window.addEventListener(event, hideStatusBarTooltip, { capture: true, passive: true })
        );
    }
};

export const releaseStatusBarTooltipHide = () => {
    if (refCount === 0) {
        return;
    }
    refCount -= 1;
    if (refCount === 0) {
        TOOLTIP_HIDE_EVENTS.forEach(event =>
            window.removeEventListener(event, hideStatusBarTooltip, { capture: true })
        );
    }
};
